let _user = null;

export function setUser (remoteUser) {
    _user = remoteUser;
}

export function user () {
    return _user;
};
